<template>
  <div class="page-wrap object-view">
    <div class="page-head">
      <div class="breadcrumbs">
        <div class="h1">
          <router-link class="link-not-like" to="/objects/"> {{ $vuetify.lang.t('$vuetify.menu.objects') }}

          </router-link>
        </div>
        <svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.27539 13.7068L7.48229 7.49989L1.27539 1.29299" stroke="#2C1521" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <div class="h1">
          {{ currentObject.name }}
        </div>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <button class="btn-icon btn-action" v-bind="attrs" v-on="on" @click="downloadAllCommentFiles">
              <picture>
                <download-icon/>
              </picture>
            </button>
          </template>
          <span>{{ $vuetify.lang.t("$vuetify.downloadAllFiles") }}</span>
        </v-tooltip>
      </div>
    </div>

    <div class="profile object">
      <div class="profile-main cards__single">
        <div class="profile-main__header">
          <div class="profile-main__photos" v-if="screenWidth<1150">
            <v-carousel v-model="slider" height="300"
                        :cycle="false"
                        :show-arrows="true"
                        :hide-delimiters="true"
                        hide-delimiter-background>
              <v-carousel-item :src="$media_url + currentObject.photo_path">
              </v-carousel-item>
              <v-carousel-item>
                <iframe loading="lazy"
                        allowfullscreen
                        referrerpolicy="no-referrer-when-downgrade"
                        :src="'https://www.google.com/maps/embed/v1/place?key=AIzaSyCLXQMTRi0e4wGAYd69wt8BFZgpv3YaO5Q&q='+ currentObject.street + '+' + currentObject.house + '+' + currentObject.city"
                        width="390" height="300"
                        style="max-width: 100%"></iframe>
              </v-carousel-item>
            </v-carousel>
          </div>
          <div class="profile-main__photos flex" v-else>
            <img class="object-header__img" :src="$media_url + currentObject.photo_path" alt=""/>
            <iframe loading="lazy"
                    allowfullscreen
                    referrerpolicy="no-referrer-when-downgrade"
                    style="max-width: 50%;"
                    :src="'https://www.google.com/maps/embed/v1/place?key=AIzaSyCLXQMTRi0e4wGAYd69wt8BFZgpv3YaO5Q&q='+ currentObject.street + '+' + currentObject.house + '+' + currentObject.city"
            ></iframe>
          </div>

          <div class="profile-main__name h2">
            {{ currentObject.name }}
          </div>
          <div class="profile-main__post"></div>
        </div>

        <div class="profile-main__options">
          <div class="profile-main__option">
            <div class="profile-main__option-icon">
              <svg width="18" height="24" viewBox="0 0 18 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M4.45059 7.10029C4.72906 7.10029 4.99614 6.98967 5.19305 6.79276C5.38996 6.59584 5.50059 6.32877 5.50059 6.05029C5.50059 5.77182 5.38996 5.50474 5.19305 5.30783C4.99614 5.11092 4.72906 5.00029 4.45059 5.00029C4.17211 5.00029 3.90504 5.11092 3.70812 5.30783C3.51121 5.50474 3.40059 5.77182 3.40059 6.05029C3.40059 6.32877 3.51121 6.59584 3.70812 6.79276C3.90504 6.98967 4.17211 7.10029 4.45059 7.10029Z"
                  fill="#557EAE"/>
                <path
                  d="M5.50059 10.2503C5.50059 10.5288 5.38996 10.7958 5.19305 10.9928C4.99614 11.1897 4.72906 11.3003 4.45059 11.3003C4.17211 11.3003 3.90504 11.1897 3.70812 10.9928C3.51121 10.7958 3.40059 10.5288 3.40059 10.2503C3.40059 9.97182 3.51121 9.70475 3.70812 9.50783C3.90504 9.31092 4.17211 9.20029 4.45059 9.20029C4.72906 9.20029 4.99614 9.31092 5.19305 9.50783C5.38996 9.70475 5.50059 9.97182 5.50059 10.2503Z"
                  fill="#557EAE"/>
                <path
                  d="M4.45059 15.5003C4.58847 15.5003 4.72501 15.4731 4.8524 15.4204C4.9798 15.3676 5.09555 15.2903 5.19305 15.1928C5.29055 15.0953 5.36789 14.9795 5.42066 14.8521C5.47343 14.7247 5.50059 14.5882 5.50059 14.4503C5.50059 14.3124 5.47343 14.1759 5.42066 14.0485C5.36789 13.9211 5.29055 13.8053 5.19305 13.7078C5.09555 13.6103 4.9798 13.533 4.8524 13.4802C4.72501 13.4275 4.58847 13.4003 4.45059 13.4003C4.17211 13.4003 3.90504 13.5109 3.70812 13.7078C3.51121 13.9047 3.40059 14.1718 3.40059 14.4503C3.40059 14.7288 3.51121 14.9958 3.70812 15.1928C3.90504 15.3897 4.17211 15.5003 4.45059 15.5003Z"
                  fill="#557EAE"/>
                <path
                  d="M9.70059 6.05029C9.70059 6.32877 9.58996 6.59584 9.39305 6.79276C9.19614 6.98967 8.92906 7.10029 8.65059 7.10029C8.37211 7.10029 8.10504 6.98967 7.90812 6.79276C7.71121 6.59584 7.60059 6.32877 7.60059 6.05029C7.60059 5.77182 7.71121 5.50474 7.90812 5.30783C8.10504 5.11092 8.37211 5.00029 8.65059 5.00029C8.92906 5.00029 9.19614 5.11092 9.39305 5.30783C9.58996 5.50474 9.70059 5.77182 9.70059 6.05029Z"
                  fill="#557EAE"/>
                <path
                  d="M8.65059 11.3003C8.92906 11.3003 9.19614 11.1897 9.39305 10.9928C9.58996 10.7958 9.70059 10.5288 9.70059 10.2503C9.70059 9.97182 9.58996 9.70475 9.39305 9.50783C9.19614 9.31092 8.92906 9.20029 8.65059 9.20029C8.37211 9.20029 8.10504 9.31092 7.90812 9.50783C7.71121 9.70475 7.60059 9.97182 7.60059 10.2503C7.60059 10.5288 7.71121 10.7958 7.90812 10.9928C8.10504 11.1897 8.37211 11.3003 8.65059 11.3003Z"
                  fill="#557EAE"/>
                <path
                  d="M9.70059 14.4503C9.70059 14.7288 9.58996 14.9958 9.39305 15.1928C9.19614 15.3897 8.92906 15.5003 8.65059 15.5003C8.37211 15.5003 8.10504 15.3897 7.90812 15.1928C7.71121 14.9958 7.60059 14.7288 7.60059 14.4503C7.60059 14.1718 7.71121 13.9047 7.90812 13.7078C8.10504 13.5109 8.37211 13.4003 8.65059 13.4003C8.92906 13.4003 9.19614 13.5109 9.39305 13.7078C9.58996 13.9047 9.70059 14.1718 9.70059 14.4503Z"
                  fill="#557EAE"/>
                <path
                  d="M12.8506 15.5003C12.9885 15.5003 13.125 15.4731 13.2524 15.4204C13.3798 15.3676 13.4955 15.2903 13.5931 15.1928C13.6906 15.0953 13.7679 14.9795 13.8207 14.8521C13.8734 14.7247 13.9006 14.5882 13.9006 14.4503C13.9006 14.3124 13.8734 14.1759 13.8207 14.0485C13.7679 13.9211 13.6906 13.8053 13.5931 13.7078C13.4955 13.6103 13.3798 13.533 13.2524 13.4802C13.125 13.4275 12.9885 13.4003 12.8506 13.4003C12.5721 13.4003 12.305 13.5109 12.1081 13.7078C11.9112 13.9047 11.8006 14.1718 11.8006 14.4503C11.8006 14.7288 11.9112 14.9958 12.1081 15.1928C12.305 15.3897 12.5721 15.5003 12.8506 15.5003Z"
                  fill="#557EAE"/>
                <path
                  d="M1.30059 23.2003C1.11493 23.2003 0.936887 23.1265 0.805611 22.9953C0.674336 22.864 0.600586 22.6859 0.600586 22.5003V2.90029C0.600586 2.34334 0.821835 1.8092 1.21566 1.41537C1.60949 1.02154 2.14363 0.800293 2.70059 0.800293H11.1006C11.6575 0.800293 12.1917 1.02154 12.5855 1.41537C12.9793 1.8092 13.2006 2.34334 13.2006 2.90029V9.20029H15.3006C15.8575 9.20029 16.3917 9.42154 16.7855 9.81537C17.1793 10.2092 17.4006 10.7433 17.4006 11.3003V22.5003C17.4006 22.6859 17.3268 22.864 17.1956 22.9953C17.0643 23.1265 16.8862 23.2003 16.7006 23.2003H1.30059ZM2.00059 2.90029V21.8003H4.80059V18.3003C4.80059 18.1146 4.87434 17.9366 5.00561 17.8053C5.13689 17.674 5.31494 17.6003 5.50059 17.6003H12.5006C12.6862 17.6003 12.8643 17.674 12.9956 17.8053C13.1268 17.9366 13.2006 18.1146 13.2006 18.3003V21.8003H16.0006V11.3003C16.0006 11.1146 15.9268 10.9366 15.7956 10.8053C15.6643 10.674 15.4862 10.6003 15.3006 10.6003H12.5006C12.3149 10.6003 12.1369 10.5265 12.0056 10.3953C11.8743 10.264 11.8006 10.0859 11.8006 9.90029V2.90029C11.8006 2.71464 11.7268 2.53659 11.5956 2.40532C11.4643 2.27404 11.2862 2.20029 11.1006 2.20029H2.70059C2.51493 2.20029 2.33689 2.27404 2.20561 2.40532C2.07434 2.53659 2.00059 2.71464 2.00059 2.90029ZM11.8006 19.0003H9.70059V21.8003H11.8006V19.0003ZM8.30059 19.0003H6.20059V21.8003H8.30059V19.0003Z"
                  fill="#557EAE"/>
              </svg>
            </div>
            <div class="profile-main__option-title">
              {{ $vuetify.lang.t('$vuetify.objectNumber') }}

            </div>

            <div class="profile-main__option-val">
              {{ currentObject.number }}
            </div>
          </div>
          <div class="profile-main__option">
            <div class="profile-main__option-icon">
              <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M8.59642 1.34307C8.98187 0.996754 9.48175 0.805176 9.99992 0.805176C10.5181 0.805176 11.018 0.996754 11.4034 1.34307L19.1034 8.26187C19.3223 8.45874 19.4974 8.69946 19.6173 8.96838C19.7372 9.23731 19.7992 9.52843 19.7992 9.82287V19.6999C19.7992 20.2568 19.578 20.791 19.1841 21.1848C18.7903 21.5786 18.2562 21.7999 17.6992 21.7999H14.1992C13.6423 21.7999 13.1081 21.5786 12.7143 21.1848C12.3205 20.791 12.0992 20.2568 12.0992 19.6999V14.7999C12.0992 14.6142 12.0255 14.4362 11.8942 14.3049C11.7629 14.1736 11.5849 14.0999 11.3992 14.0999H8.59922C8.41357 14.0999 8.23552 14.1736 8.10424 14.3049C7.97297 14.4362 7.89922 14.6142 7.89922 14.7999V19.6999C7.89922 20.2568 7.67797 20.791 7.28414 21.1848C6.89032 21.5786 6.35617 21.7999 5.79922 21.7999H2.29922C1.74226 21.7999 1.20812 21.5786 0.814295 21.1848C0.420468 20.791 0.199219 20.2568 0.199219 19.6999V9.82287C0.199219 9.22787 0.451219 8.66087 0.896419 8.26187L8.59642 1.34307ZM10.4668 2.38467C10.3384 2.26936 10.1718 2.20558 9.99922 2.20558C9.8266 2.20558 9.66008 2.26936 9.53162 2.38467L1.83162 9.30347C1.75867 9.36894 1.7003 9.44901 1.66026 9.53849C1.62023 9.62796 1.59943 9.72484 1.59922 9.82287V19.6999C1.59922 19.8855 1.67297 20.0636 1.80424 20.1948C1.93552 20.3261 2.11357 20.3999 2.29922 20.3999H5.79922C5.98487 20.3999 6.16292 20.3261 6.29419 20.1948C6.42547 20.0636 6.49922 19.8855 6.49922 19.6999V14.7999C6.49922 14.2429 6.72047 13.7088 7.1143 13.3149C7.50812 12.9211 8.04227 12.6999 8.59922 12.6999H11.3992C11.9562 12.6999 12.4903 12.9211 12.8841 13.3149C13.278 13.7088 13.4992 14.2429 13.4992 14.7999V19.6999C13.4992 19.8855 13.573 20.0636 13.7042 20.1948C13.8355 20.3261 14.0136 20.3999 14.1992 20.3999H17.6992C17.8849 20.3999 18.0629 20.3261 18.1942 20.1948C18.3255 20.0636 18.3992 19.8855 18.3992 19.6999V9.82287C18.399 9.72484 18.3782 9.62796 18.3382 9.53849C18.2981 9.44901 18.2398 9.36894 18.1668 9.30347L10.4668 2.38467Z"
                  fill="#557EAE"/>
              </svg>
            </div>
            <div class="profile-main__option-title">
              {{ $vuetify.lang.t('$vuetify.objectAddress') }}
            </div>

            <div class="profile-main__option-val">
              <a target="_blank"
                 :href="'https://www.google.com/maps/search/?api=1&query='+currentObject.street + '+' + currentObject.house + '+' + currentObject.city">
                {{ currentObject.street }} {{ currentObject.house }}{{
                  currentObject.entrance ? currentObject.entrance +
                    ' ' : ''
                }}
                {{ currentObject.flat ? currentObject.flat + ', ' : ', ' }}{{ currentObject.index }}
                {{ currentObject.city }}, {{ currentObject.country }}
              </a>
            </div>
          </div>
          <div class="profile-main__option">
            <div class="profile-main__option-icon">
              <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M13.4008 12.0003C14.1434 12.0003 14.8556 12.2953 15.3807 12.8204C15.9058 13.3455 16.2008 14.0577 16.2008 14.8003V16.9003C16.2008 19.7759 13.2776 21.8003 8.50078 21.8003C3.72398 21.8003 0.800781 19.7759 0.800781 16.9003V14.8003C0.800781 14.0577 1.09578 13.3455 1.62088 12.8204C2.14598 12.2953 2.85818 12.0003 3.60078 12.0003H13.4008ZM13.4008 13.4003H3.60078C3.22948 13.4003 2.87338 13.5478 2.61083 13.8103C2.34828 14.0729 2.20078 14.429 2.20078 14.8003V16.9003C2.20078 18.8701 4.41138 20.4003 8.50078 20.4003C12.5902 20.4003 14.8008 18.8701 14.8008 16.9003V14.8003C14.8008 14.429 14.6533 14.0729 14.3907 13.8103C14.1282 13.5478 13.7721 13.4003 13.4008 13.4003ZM20.4008 12.0003C21.1434 12.0003 21.8556 12.2953 22.3807 12.8204C22.9058 13.3455 23.2008 14.0577 23.2008 14.8003V15.5003C23.2008 18.4249 21.0056 20.4003 16.9008 20.4003C16.7034 20.4003 16.5088 20.3961 16.3212 20.3863C16.6124 20.0475 16.856 19.6835 17.052 19.2929L17.1878 18.9947H17.2424C20.3672 18.9037 21.8008 17.5443 21.8008 15.5003V14.8003C21.8008 14.429 21.6533 14.0729 21.3907 13.8103C21.1282 13.5478 20.7721 13.4003 20.4008 13.4003H17.3614C17.1782 12.8838 16.8957 12.4082 16.5298 12.0003H20.4008ZM8.50078 0.800293C9.14426 0.800293 9.78143 0.927035 10.3759 1.17328C10.9704 1.41953 11.5106 1.78046 11.9656 2.23547C12.4206 2.69048 12.7815 3.23065 13.0278 3.82514C13.274 4.41964 13.4008 5.05682 13.4008 5.70029C13.4008 6.34377 13.274 6.98095 13.0278 7.57544C12.7815 8.16994 12.4206 8.71011 11.9656 9.16512C11.5106 9.62012 10.9704 9.98106 10.3759 10.2273C9.78143 10.4736 9.14426 10.6003 8.50078 10.6003C7.20122 10.6003 5.95489 10.084 5.03596 9.16512C4.11703 8.24619 3.60078 6.99985 3.60078 5.70029C3.60078 4.40073 4.11703 3.1544 5.03596 2.23547C5.95489 1.31654 7.20122 0.800293 8.50078 0.800293ZM18.3008 3.60029C19.229 3.60029 20.1193 3.96904 20.7757 4.62542C21.432 5.2818 21.8008 6.17204 21.8008 7.10029C21.8008 8.02855 21.432 8.91879 20.7757 9.57517C20.1193 10.2315 19.229 10.6003 18.3008 10.6003C17.3725 10.6003 16.4823 10.2315 15.8259 9.57517C15.1695 8.91879 14.8008 8.02855 14.8008 7.10029C14.8008 6.17204 15.1695 5.2818 15.8259 4.62542C16.4823 3.96904 17.3725 3.60029 18.3008 3.60029ZM8.50078 2.20029C7.57252 2.20029 6.68228 2.56904 6.02591 3.22542C5.36953 3.8818 5.00078 4.77204 5.00078 5.70029C5.00078 6.62855 5.36953 7.51879 6.02591 8.17517C6.68228 8.83154 7.57252 9.20029 8.50078 9.20029C9.42904 9.20029 10.3193 8.83154 10.9757 8.17517C11.632 7.51879 12.0008 6.62855 12.0008 5.70029C12.0008 4.77204 11.632 3.8818 10.9757 3.22542C10.3193 2.56904 9.42904 2.20029 8.50078 2.20029ZM18.3008 5.00029C17.7438 5.00029 17.2097 5.22154 16.8159 5.61537C16.422 6.0092 16.2008 6.54334 16.2008 7.10029C16.2008 7.65725 16.422 8.19139 16.8159 8.58522C17.2097 8.97904 17.7438 9.20029 18.3008 9.20029C18.8577 9.20029 19.3919 8.97904 19.7857 8.58522C20.1795 8.19139 20.4008 7.65725 20.4008 7.10029C20.4008 6.54334 20.1795 6.0092 19.7857 5.61537C19.3919 5.22154 18.8577 5.00029 18.3008 5.00029Z"
                  fill="#557EAE"/>
              </svg>
            </div>
            <div class="profile-main__option-title">{{ $vuetify.lang.t('$vuetify.accounting.card.client') }}</div>

            <div class="profile-main__option-val">
              <router-link :to="'/clients/'+currentObject.client_id.id" v-if="currentObject.client_id">
                {{ currentObject.client_id.name }}
              </router-link>
              <router-link :to="'/organization/'+currentObject.org_client.id" v-if="currentObject.org_client">
                {{ currentObject.org_client.name }}
              </router-link>
            </div>
          </div>
          <div class="profile-main__option">
            <div class="profile-main__option-icon">
              <svg width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M5.6 17.6008C5.41435 17.6008 5.2363 17.6745 5.10503 17.8058C4.97375 17.9371 4.9 18.1151 4.9 18.3008C4.9 18.4864 4.97375 18.6645 5.10503 18.7958C5.2363 18.927 5.41435 19.0008 5.6 19.0008H8.4C8.58565 19.0008 8.7637 18.927 8.89497 18.7958C9.02625 18.6645 9.1 18.4864 9.1 18.3008C9.1 18.1151 9.02625 17.9371 8.89497 17.8058C8.7637 17.6745 8.58565 17.6008 8.4 17.6008H5.6Z"
                  fill="#557EAE"/>
                <path
                  d="M2.8 0.800781C2.05739 0.800781 1.3452 1.09578 0.820101 1.62088C0.294999 2.14598 0 2.85818 0 3.60078V20.4008C0 21.1434 0.294999 21.8556 0.820101 22.3807C1.3452 22.9058 2.05739 23.2008 2.8 23.2008H11.2C11.9426 23.2008 12.6548 22.9058 13.1799 22.3807C13.705 21.8556 14 21.1434 14 20.4008V3.60078C14 2.85818 13.705 2.14598 13.1799 1.62088C12.6548 1.09578 11.9426 0.800781 11.2 0.800781H2.8ZM1.4 3.60078C1.4 3.22948 1.5475 2.87338 1.81005 2.61083C2.0726 2.34828 2.4287 2.20078 2.8 2.20078H11.2C11.5713 2.20078 11.9274 2.34828 12.1899 2.61083C12.4525 2.87338 12.6 3.22948 12.6 3.60078V20.4008C12.6 20.7721 12.4525 21.1282 12.1899 21.3907C11.9274 21.6533 11.5713 21.8008 11.2 21.8008H2.8C2.4287 21.8008 2.0726 21.6533 1.81005 21.3907C1.5475 21.1282 1.4 20.7721 1.4 20.4008V3.60078Z"
                  fill="#557EAE"/>
              </svg>
            </div>
            <div class="profile-main__option-title">{{ $vuetify.lang.t('$vuetify.clientPhone') }}</div>

            <div class="profile-main__option-val">
              <a v-if="currentObject.client_id && currentObject.client_id.phone " :href="'tel:' + currentObject.client_id.phone.replace(/\s/g, '')">{{
                  currentObject.client_id.phone
                }} </a>
              <a v-if="currentObject.org_client"
                 :href="'tel:' + currentObject.org_client.phone.replace(/\s/g, '')">
                {{ currentObject.org_client.phone }}
              </a>

            </div>
          </div>
          <div class="profile-main__option">
            <div class="profile-main__option-icon">
              <svg width="24" height="19" viewBox="0 0 24 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M19.7008 0.599609C20.629 0.599609 21.5193 0.968358 22.1757 1.62474C22.832 2.28111 23.2008 3.17135 23.2008 4.09961V15.2996C23.2008 16.2279 22.832 17.1181 22.1757 17.7745C21.5193 18.4309 20.629 18.7996 19.7008 18.7996H4.30078C3.37252 18.7996 2.48228 18.4309 1.82591 17.7745C1.16953 17.1181 0.800781 16.2279 0.800781 15.2996V4.09961C0.800781 3.17135 1.16953 2.28111 1.82591 1.62474C2.48228 0.968358 3.37252 0.599609 4.30078 0.599609H19.7008ZM21.8008 6.14501L12.3564 11.703C12.2671 11.7554 12.1673 11.7874 12.0642 11.7966C11.961 11.8058 11.8571 11.792 11.76 11.7562L11.6452 11.703L2.20078 6.14781V15.2996C2.20078 15.8566 2.42203 16.3907 2.81586 16.7845C3.20968 17.1784 3.74383 17.3996 4.30078 17.3996H19.7008C20.2577 17.3996 20.7919 17.1784 21.1857 16.7845C21.5795 16.3907 21.8008 15.8566 21.8008 15.2996V6.14501ZM19.7008 1.99961H4.30078C3.74383 1.99961 3.20968 2.22086 2.81586 2.61469C2.42203 3.00851 2.20078 3.54265 2.20078 4.09961V4.52241L12.0008 10.2876L21.8008 4.51961V4.09961C21.8008 3.54265 21.5795 3.00851 21.1857 2.61469C20.7919 2.22086 20.2577 1.99961 19.7008 1.99961Z"
                  fill="#557EAE"/>
              </svg>
            </div>
            <div class="profile-main__option-title">{{ $vuetify.lang.t('$vuetify.clientEmail') }}</div>

            <div class="profile-main__option-val">
              <a :href="'mailto:' + currentObject.client_id.email" v-if="currentObject.client_id">
                {{ currentObject.client_id.email }}
              </a>
              <a :href="'mailto:' + currentObject.org_client.email" v-if="currentObject.org_client">
                {{ currentObject.org_client.email }}
              </a>
            </div>
          </div>
          <router-link v-if="($parent.user.read_timings && $parent.type === 'client') || $parent.type !== 'client'"
                       class="btn btn-secondary link-not-like" :to="'/objects/' + id + '/timings'">
            {{ $vuetify.lang.t('$vuetify.menu.timings') }}
          </router-link>
          <router-link v-if="active" class="btn btn-secondary link-not-like"
                       :to="'/order/new/?object='+this.id">
            {{ $vuetify.lang.t('$vuetify.menu.addOrder') }}
          </router-link>
          <button class="btn btn-secondary" @click="openInvite">
            {{ $vuetify.lang.t('$vuetify.menu.invitePartner') }}
          </button>
        </div>
      </div>
      <div class="profile-tabs cards__single">
        <div class="profile-tabs__head">
          <div class="profile-tabs__item" :class="{ selected: tab_selected === 1 }" @click="tab_selected = 1">
            {{ $vuetify.lang.t('$vuetify.employesOnObject') }}
          </div>

          <div class="profile-tabs__item" :class="{ selected: tab_selected === 2 }" @click="tab_selected = 2">
            {{ $vuetify.lang.t('$vuetify.workList') }}
          </div>

          <div class="profile-tabs__item" :class="{ selected: tab_selected === 3 }"
               @click="tab_selected = 3; readComments()">
            {{ $vuetify.lang.t('$vuetify.comments') }}
          </div>

          <div class="profile-tabs__item" v-if="currentObject.contacts_visible || permissions.admin"
               :class="{ selected: tab_selected === 4 }"
               @click="tab_selected = 4">
            {{ $vuetify.lang.t('$vuetify.menu.contacts') }}
          </div>

          <div class="profile-tabs__item" :class="{ selected: tab_selected === 6 }" @click="tab_selected = 6">
            {{ $vuetify.lang.t('$vuetify.documents') }}
          </div>

          <div
            v-if="permissions.read.indexOf('Диаграмма') != -1"
            class="profile-tabs__item"
            :class="{ selected: tab_selected === 7 }"
            @click="tab_selected = 7">
            {{ $vuetify.lang.t('$vuetify.dgantt.title') }}
          </div>

        </div>
        <div class="profile-tabs__content objects-content">
          <div v-if="tab_selected === 1" class="profile-tabs__content-item">
            <div class="staff">
              <div v-if="geoError && active" class="error--text">
                {{ $vuetify.lang.t('$vuetify.geoError') }}: {{ geoError }}
              </div>
              <button v-if="active" class="btn btn-primary" @click="changeCheck">
                {{ check ? $vuetify.lang.t('$vuetify.checkOut') : $vuetify.lang.t('$vuetify.checkIn') }}
              </button>
              <div class="staff__item" v-for="worker in objectWorkers" :key="worker.id">
                <div class=" link-not-like staff__avatar">
                  <img v-if="worker.user_profile_id.photo_path" :src="$media_url + worker.user_profile_id.photo_path"
                       alt=""/>
                </div>

                <router-link v-if="permissions.admin" :to="'/workers/' + worker.user_profile_id.id"
                             class=" link-not-like staff__name">
                  {{ worker.user_profile_id.name }}
                  {{ worker.user_profile_id.lastname }}
                  <span class="staff__post"
                        v-if="worker.user_profile_id.position && worker.user_profile_id.position.name">({{
                      worker.user_profile_id.position.name[$vuetify.lang.current] ? worker.user_profile_id.position.name[$vuetify.lang.current] : worker.user_profile_id.position.name['eng'] ? worker.user_profile_id.position.name['eng'] : worker.user_profile_id.position.name['fin']
                    }})</span>
                </router-link>
                <div v-else class="staff__name">
                  {{ worker.user_profile_id.name }}
                  {{ worker.user_profile_id.lastname }}
                  <span class="staff__post"
                        v-if="worker.user_profile_id.position && worker.user_profile_id.position.name">({{
                      worker.user_profile_id.position.name[$vuetify.lang.current] ? worker.user_profile_id.position.name[$vuetify.lang.current] : worker.user_profile_id.position.name['eng'] ? worker.user_profile_id.position.name['eng'] : worker.user_profile_id.position.name['fin']
                    }})</span>
                </div>
                <div class="staff__contact" v-if="permissions.admin">
                  <a :href="'mailto:' + worker.user_profile_id.auth_user_id.email">
                    {{ worker.user_profile_id.auth_user_id.email }}
                  </a>
                  <a :href="'tel:' + worker.user_profile_id.phone.replace(/\s/g, '')">
                    {{ worker.user_profile_id.phone }}
                  </a>
                </div>
                <div v-if="permissions.admin && workerInfoMap[worker.user_profile_id.id]" class="staff__time-location">
                  {{ $vuetify.lang.t("$vuetify.workerOnObject") }}
                  {{ workerInfoMap[worker.user_profile_id.id].time }}
                  <a v-if="workerInfoMap[worker.user_profile_id.id].geo" target="_blank"
                     :href="'https://www.google.com/maps/search/?api=1&query='+ workerInfoMap[worker.user_profile_id.id].geo">
                    {{ $vuetify.lang.t("$vuetify.showGeo") }}
                  </a>
                </div>

                <div v-if="edit_perm" class="staff__btns">
                  <button class="btn-icon btn-action" @click="edit_worker_open(worker)">
                    <picture>
                      <edit-icon/>
                    </picture>
                  </button>
                  <button class="btn-icon btn-action" @click="confirm_worker_open(worker.id)">
                    <picture>
                      <delete-icon/>
                    </picture>
                  </button>
                </div>
              </div>
              <button v-if="!editingWorkers && edit_perm" class="btn btn-secondary mt-20 mb-40"
                      @click="editingWorkers = !editingWorkers">
                + {{ $vuetify.lang.t('$vuetify.addEmployee') }}
              </button>
            </div>
          </div>

          <div v-if="tab_selected === 2" class="profile-tabs__content-item">
            <div class="work-list">
              <button v-if="edit_perm" class="btn-icon btn-action"
                      @click="editing=!editing">
                <edit-icon/>
              </button>
              <template v-if="!editing">
                <div class="work-list__item" v-for="work in currentObject.work_description" :key="work">
                  {{ work }}
                </div>
              </template>
              <div v-if="editing" class="pr-10">
                <div class="flex astart" v-for="(work, idx) in tmp_work_description" :key="idx">
                  <v-text-field :label="$vuetify.lang.t('$vuetify.enterText')" outlined
                                v-model="tmp_work_description[idx]"
                                :rules="[$rules.required, $rules.text]"></v-text-field>
                  <button class="btn-icon btn-action" @click="tmp_work_description.splice(idx, 1)">
                    <svg width="15px" height="15px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                         xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 490 490"
                         xml:space="preserve">
                      <polygon fill="white" points="386.813,0 245,141.812 103.188,0 0,103.188 141.813,245 0,386.812 103.187,489.999 245,348.187 386.813,490
	490,386.812 348.187,244.999 490,103.187 "/>
                    </svg>
                  </button>
                </div>

                <div class="flex astart mb-20">
                  <v-text-field :label="$vuetify.lang.t('$vuetify.enterWorkText')" outlined v-model="obj_work"
                                @keyup.enter="obj_work_add">
                  </v-text-field>
                  <button class="btn btn-secondary" @click="obj_work_add">
                    + {{ $vuetify.lang.t('$vuetify.addWork') }}
                  </button>
                </div>
                <div class="sign-up__buttons btn-group">
                  <button class="btn btn-secondary" @click="editing = false">
                    + {{ $vuetify.lang.t('$vuetify.back') }}
                  </button>
                  <button class="btn btn-primary" @click="confirm_edit">
                    + {{ $vuetify.lang.t('$vuetify.save') }}
                  </button>
                </div>
              </div>
              <div class="object__todo" v-for="(item, date) in todo" :key="date">
                <div class="accordion__title mb-5">
                  <div class="accordion__title-text h2 flex">
                    {{ new Date(item.date).toLocaleDateString('ru-Ru') }}
                    <template v-if="item.date_end">
                      - {{ new Date(item.date_end).toLocaleDateString('ru-Ru') }}
                    </template>
                  </div>
                </div>
                <div v-for="(data, obj) in item.objects" :key="obj">
                  <template v-for="task in data.data">
                    <div class="todo__worker align-baseline" :key="task.id.toString() + obj">
                      <div>{{ task.time.substring(0, 5) }} -</div>
                      <div>
                        <template v-for="profile in task.user_profiles">
                          <div class="bolder" :key="task.id +'_' + profile.id">
                            {{ profile.name }} {{ profile.lastname }}
                          </div>
                        </template>
                      </div>
                      <div v-html="task.comment"></div>
                    </div>
                  </template>
                </div>
              </div>
              <router-link class="btn btn-secondary" :to="'/objects/'+id+'/todo'">
                {{ $vuetify.lang.t("$vuetify.showHistory") }}
              </router-link>
            </div>
          </div>

          <div v-if="tab_selected === 3" class="profile-tabs__content-item">
            <div class="comments">
              <div class="comments__list" id="comments__list">
                <template v-if="comments.length === 0">

                  <div class="comments__item">
                    <div class="comments__avatar avatar"></div>
                    <div class="comments__name"></div>
                    <div class="staff__btns comments__btns"></div>
                    <div class="comments__text">{{ $vuetify.lang.t("$vuetify.noDataText") }}</div>
                  </div>
                </template>
                <template v-for="com in comments">
                  <div class="comments__item" :key="com.id">
                    <div class="comments__avatar avatar">
                      <img v-if="com.user_profile_id && com.user_profile_id.photo_path"
                           :src="$media_url + com.user_profile_id.photo_path"
                           alt=""/>
                      <img v-if="com.auth_user && com.auth_user.client && com.auth_user.client.logo_path"
                           :src="$media_url + com.auth_user.client.logo_path"
                           alt=""/>
                    </div>
                    <div class="comments__name" v-if="com.user_profile_id">
                      <router-link :to="'/workers/' + com.user_profile_id.id"
                                   class="link-not-like">
                        {{ com.user_profile_id.name }}
                        {{ com.user_profile_id.lastname }}
                      </router-link>
                      <span class="comments__post"
                            v-if=" com.user_profile_id.position &&  com.user_profile_id.position.name">({{
                          com.user_profile_id.position.name[$vuetify.lang.current] ? com.user_profile_id.position.name[$vuetify.lang.current] : com.user_profile_id.position.name['eng'] ? com.user_profile_id.position.name['eng'] : com.user_profile_id.position.name['fin']
                        }})</span>
                    </div>
                    <div class="comments__name" v-else>
                      <router-link :to="'/clients/' + com.auth_user.client.id"
                                   class="link-not-like">
                        {{ com.auth_user.client.name }}
                      </router-link>
                    </div>
                    <div class="staff__btns comments__btns">
                      <button v-if="checkFiles(com)" class="btn-icon btn-action"
                              @click="downloadCommentFiles(com)">
                        <picture>
                          <download-icon/>
                        </picture>
                      </button>
                      <button class="btn-icon btn-action" @click="answerStart(com.id)">
                        <picture>
                          <svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root css-1om0hkc"
                               focusable="false"
                               aria-hidden="true" viewBox="0 0 24 24" data-testid="ReplyOutlinedIcon">
                            <path d="M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z"></path>
                          </svg>
                        </picture>
                      </button>
                      <button class="btn-icon btn-action" @click="confirm_comment_open(com.id)"
                              v-if="permissions.admin || (com.user_profile_id && profile === com.user_profile_id.id)">
                        <picture>
                          <delete-icon/>
                        </picture>
                      </button>
                      <button
                        v-if="new Date(com.create_date)>=new Date('2022-08-26') && com.user_profile_id && profile === com.user_profile_id.id"
                        class="btn-icon btn-action" @click="edit_comment_open(com)">
                        <picture>
                          <edit-icon/>
                        </picture>
                      </button>
                    </div>

                    <div v-if="new Date(com.create_date)<new Date('2022-08-26')" class="comments__text">
                      <pre v-if="translated.indexOf(com.id) === -1" v-html="com.text"></pre>
                      <pre v-else v-html="com.translated"></pre>
                    </div>
                    <div v-else class="comments__content">
                      <div class="comments__text">
                        <pre v-if="translated.indexOf(com.id) === -1" v-html="com.display_text"></pre>
                        <pre v-else v-html="com.translated"></pre>
                        <div
                          v-if="(permissions.admin || (com.user_profile_id && profile === com.user_profile_id.id)) && com.order_id">
                          <router-link :to="'/order/edit/'+com.order_id">{{
                              $vuetify.lang.t('$vuetify.menu.editOrder')
                            }}
                          </router-link>
                        </div>

                      </div>
                      <div class="comments__files">
                        <template v-for="(doc, index) in com.files">
                          <img :key="doc"
                               v-if="(['png', 'jpg', 'jpeg', 'JPG', 'PNG', 'JPEG'].includes(doc.substr(doc.lastIndexOf('.') + 1)))"
                               :src="$media_url + doc" alt="photo" @click="openLightbox(com, index)"/>
                          <v-tooltip top v-else :key="doc">
                            <template v-slot:activator="{ on, attrs }">
                              <a :href="$media_url + doc"
                                 v-bind="attrs"
                                 v-on="on"
                                 target="_blank"
                              >
                                <img class="document-row__photo" src="../../assets/img/document-preview.svg"
                                     alt="">
                              </a>
                            </template>
                            <span>{{
                                doc.substr(doc.lastIndexOf('/') + 1, doc.lastIndexOf('_') + 1) + doc.substr(doc.lastIndexOf('.'))
                              }}</span>
                          </v-tooltip>
                        </template>
                      </div>
                    </div>
                    <div class="comments__date">
                      {{ new Date(com.create_date).toLocaleDateString('ru-Ru') }},
                      {{ new Date(com.create_date).toLocaleTimeString('ru-Ru').substr(0, 5) }}
                      <span v-if="translated.indexOf(com.id) === -1" class="link cp text-right"
                            @click="translateCom(com)">
                        {{ $vuetify.lang.t("$vuetify.translate") }}
                      </span>
                      <span v-else class="link cp text-right" @click="translated.splice(translated.indexOf(com.id), 1)">
                        {{ $vuetify.lang.t("$vuetify.showOriginal") }}
                      </span>
                    </div>
                  </div>
                  <div class="comments__answer comments__item" v-for="com_ans in answers[com.id]" :key="com_ans.id">
                    <div class="comments__avatar avatar">
                      <img v-if="com_ans.user_profile_id && com_ans.user_profile_id.photo_path"
                           :src="$media_url + com_ans.user_profile_id.photo_path"
                           alt=""/>
                      <img v-if="com_ans.auth_user && com_ans.auth_user.client && com_ans.auth_user.client.logo_path"
                           :src="$media_url + com_ans.auth_user.client.logo_path"
                           alt=""/>
                    </div>
                    <div class="comments__name" v-if="com_ans.user_profile_id">
                      <router-link :to="'/workers/' + com_ans.user_profile_id.id"
                                   class="link-not-like">
                        {{ com_ans.user_profile_id.name }}
                        {{ com_ans.user_profile_id.lastname }}
                      </router-link>
                      <span class="comments__post"
                            v-if=" com_ans.user_profile_id.position &&  com_ans.user_profile_id.position.name">({{
                          com_ans.user_profile_id.position.name[$vuetify.lang.current] ? com_ans.user_profile_id.position.name[$vuetify.lang.current] : com_ans.user_profile_id.position.name['eng'] ? com_ans.user_profile_id.position.name['eng'] : com_ans.user_profile_id.position.name['fin']
                        }})</span>
                    </div>
                    <div class="comments__name" v-else>
                      <router-link :to="'/clients/' + com_ans.auth_user.client.id"
                                   class="link-not-like">
                        {{ com_ans.auth_user.client.name }}
                      </router-link>
                    </div>
                    <div class="staff__btns comments__btns">
                      <button v-if="checkFiles(com_ans)" class="btn-icon btn-action"
                              @click="downloadCommentFiles(com_ans)">
                        <picture>
                          <download-icon/>
                        </picture>
                      </button>
                      <button class="btn-icon btn-action" @click="confirm_comment_open(com_ans.id)"
                              v-if="permissions.admin || (com_ans.user_profile_id && profile === com_ans.user_profile_id.id)">
                        <picture>
                          <delete-icon/>
                        </picture>
                      </button>
                      <button
                        v-if="new Date(com_ans.create_date)>=new Date('2022-08-26') && com_ans.user_profile_id && profile === com_ans.user_profile_id.id"
                        class="btn-icon btn-action" @click="edit_comment_open(com_ans)">
                        <picture>
                          <edit-icon/>
                        </picture>
                      </button>
                    </div>

                    <div v-if="new Date(com_ans.create_date)<new Date('2022-08-26')" class="comments__text">
                      <pre v-if="translated.indexOf(com_ans.id) === -1" v-html="com_ans.text"></pre>
                      <pre v-else v-html="com_ans.translated"></pre>
                    </div>
                    <div v-else class="comments__content">
                      <div class="comments__text">
                        <pre v-if="translated.indexOf(com_ans.id) === -1">{{ com_ans.text }}</pre>
                        <pre v-else>{{ com_ans.translated }}</pre>
                      </div>
                      <div class="comments__files">
                        <template v-for="(doc, index) in com_ans.files">
                          <img :key="doc"
                               v-if="(['png', 'jpg', 'jpeg', 'JPG', 'PNG', 'JPEG'].includes(doc.substr(doc.lastIndexOf('.') + 1)))"
                               :src="$media_url + doc" alt="photo" @click="openLightbox(com_ans, index)"/>
                          <v-tooltip top v-else :key="doc">
                            <template v-slot:activator="{ on, attrs }">
                              <a :href="$media_url + doc"
                                 v-bind="attrs"
                                 v-on="on"
                                 target="_blank"
                              >
                                <img class="document-row__photo" src="../../assets/img/document-preview.svg"
                                     alt="">
                              </a>
                            </template>
                            <span>{{
                                doc.substr(doc.lastIndexOf('/') + 1, doc.lastIndexOf('_') + 1) + doc.substr(doc.lastIndexOf('.'))
                              }}</span>
                          </v-tooltip>
                        </template>
                      </div>
                    </div>
                    <div class="comments__date">
                      {{ new Date(com_ans.create_date).toLocaleDateString('ru-Ru') }},
                      {{ new Date(com_ans.create_date).toLocaleTimeString('ru-Ru').substr(0, 5) }}
                      <span v-if="translated.indexOf(com_ans.id) === -1" class="link cp text-right"
                            @click="translateCom(com_ans)">
                        {{ $vuetify.lang.t("$vuetify.translate") }}
                      </span>
                      <span v-else class="link cp text-right"
                            @click="translated.splice(translated.indexOf(com_ans.id), 1)">
                        {{ $vuetify.lang.t("$vuetify.showOriginal") }}
                      </span>
                    </div>
                  </div>
                </template>
              </div>
              <div v-if="newComment.id" class="flex justify-between">
                <span class="bolder">{{ $vuetify.lang.t("$vuetify.editingComment") }}</span>
                <button class="btn-icon" @click="cancel_edit_comment">
                  <v-icon>mdi-close</v-icon>
                </button>
              </div>
              <v-form :disabled="!active" class="comments__input" ref="comment" @submit.prevent=""
                      style="max-height: 50%">
                <button :disabled="!active" class="cp" @click="clickInput">
                  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M3.39181 20.5C2.52112 20.5 1.74789 20.1506 1.07212 19.4517C0.357375 18.7126 0 17.8155 0 16.7605C0 15.7056 0.357375 14.8085 1.07212 14.0693L12.2807 1.77245C12.8525 1.16768 13.512 0.777947 14.2593 0.603238C15.0065 0.428528 15.7635 0.475565 16.5302 0.744349C17.2969 1.01313 18.0052 1.47679 18.655 2.13531C18.8629 2.36378 19.0546 2.61576 19.23 2.89126C19.4055 3.16677 19.5484 3.45571 19.6589 3.75809C19.7693 4.06048 19.8538 4.37966 19.9123 4.71564C19.9708 5.05162 20 5.3876 20 5.72358C19.974 7.14814 19.5062 8.33751 18.5965 9.29169L10.117 18.6051C10 18.7395 9.85705 18.81 9.68811 18.8167C9.51917 18.8235 9.37297 18.7663 9.24951 18.6454C9.12606 18.5244 9.06108 18.3732 9.05458 18.1918C9.04808 18.0104 9.10331 17.8525 9.22027 17.7181L17.6998 8.4047C18.3886 7.67899 18.7394 6.77856 18.7524 5.70342C18.7654 4.62828 18.434 3.74801 17.7583 3.06261C17.3424 2.61912 16.8811 2.28314 16.3743 2.05467C15.8674 1.82621 15.3216 1.75229 14.7368 1.83293C14.152 1.91356 13.6322 2.18907 13.1774 2.65944L1.96881 14.9563C1.48798 15.4536 1.24756 16.0516 1.24756 16.7505C1.24756 17.4493 1.48798 18.0473 1.96881 18.5446C2.18973 18.7731 2.43015 18.9444 2.69006 19.0586C2.94997 19.1729 3.22287 19.2166 3.50877 19.1897C4.08057 19.1628 4.61339 18.8873 5.10721 18.3632L14.0156 8.56597C14.0806 8.49878 14.1423 8.42822 14.2008 8.35431C14.2593 8.28039 14.321 8.19304 14.386 8.09224C14.4509 7.99145 14.5029 7.88393 14.5419 7.7697C14.5809 7.65547 14.6069 7.54123 14.6199 7.427C14.6329 7.31277 14.6134 7.19517 14.5614 7.07422C14.5094 6.95327 14.4314 6.83904 14.3275 6.73152C14.0806 6.46274 13.8402 6.34178 13.6062 6.36866C13.3593 6.39554 13.0799 6.56353 12.768 6.87263L6.06238 14.2508C5.98441 14.3314 5.89344 14.3885 5.78947 14.4221C5.68551 14.4557 5.5783 14.4591 5.46784 14.4322C5.35738 14.4053 5.26316 14.3516 5.18518 14.2709C5.05523 14.15 4.99025 14.0021 4.99025 13.8274C4.99025 13.6527 5.04873 13.4982 5.16569 13.3638L11.8713 5.96549C12.4042 5.42792 12.9435 5.13225 13.4893 5.0785C14.1131 5.02474 14.6849 5.26665 15.2047 5.80422C15.6985 6.30147 15.9162 6.88607 15.8577 7.55803C15.7992 8.22999 15.4841 8.86164 14.9123 9.45296L6.0039 19.2703C5.27615 20.0229 4.46394 20.4261 3.56725 20.4798C3.54126 20.4798 3.51202 20.4832 3.47953 20.4899C3.44704 20.4966 3.4178 20.5 3.39181 20.5Z"
                      fill="#ADB2B7"/>
                  </svg>
                </button>
                <v-file-input :disabled="!active" class="file-input--hide" v-model="commentPhoto"
                              placeholder="Загрузить изображение (jpg, png)" id="photo" multiple
                              @change="showFile(this)" :rules="[$rules.multipleFileSize]">
                </v-file-input>
                <v-textarea :disabled="!active" v-model="newComment.text"
                            :label="$vuetify.lang.t('$vuetify.enterText')" outlined
                            id="textarea" row-height="9" auto-grow rows="1"
                            append-icon="mdi-emoticon-happy-outline"
                >
                  <template v-slot:append>
                    <v-menu v-model="show_smiles" top left close-on-content-click offset-y attach>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon @click="show_smiles=!show_smiles" v-bind="attrs" v-on="on">
                          <v-icon>mdi-emoticon-happy-outline</v-icon>
                        </v-btn>
                      </template>
                      <v-card>
                        <v-card-text style="width: 220px">
                          <span class="cp" @click.stop="enterSmile('😀')">😀</span>
                          <span class="cp" @click.stop="enterSmile('😉')">😉</span>
                          <span class="cp" @click.stop="enterSmile('😂')">😂</span>
                          <span class="cp" @click.stop="enterSmile('😡')">😡</span>
                          <span class="cp" @click.stop="enterSmile('😱')">😱</span>
                          <span class="cp" @click.stop="enterSmile('🤨')">🤨</span>
                          <span class="cp" @click.stop="enterSmile('😍')">😍</span>
                          <span class="cp" @click.stop="enterSmile('👌')">👌</span>
                          <span class="cp" @click.stop="enterSmile('👍')">👍</span>
                          <span class="cp" @click.stop="enterSmile('👎')">👎</span>
                        </v-card-text>
                      </v-card>
                    </v-menu>
                  </template>
                </v-textarea>

                <button :disabled="!active" class="cp" @click="submitComment">
                  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M1.26593 0.96077L19.6919 10.04C19.7924 10.0895 19.877 10.1661 19.9362 10.2613C19.9954 10.3564 20.0267 10.4662 20.0267 10.5782C20.0267 10.6902 19.9954 10.8 19.9362 10.8951C19.877 10.9902 19.7924 11.0669 19.6919 11.1164L1.26473 20.1956C1.1615 20.2463 1.04586 20.2663 0.9316 20.2531C0.817337 20.24 0.70926 20.1942 0.620241 20.1214C0.531223 20.0486 0.465014 19.9517 0.429501 19.8423C0.393987 19.7329 0.390666 19.6156 0.419932 19.5044L2.78273 10.5836L0.418732 1.65317C0.388982 1.54171 0.391995 1.42403 0.427412 1.31424C0.462829 1.20444 0.529147 1.10719 0.618423 1.03412C0.707699 0.961055 0.816147 0.915275 0.930775 0.902265C1.0454 0.889256 1.16135 0.909568 1.26473 0.96077H1.26593ZM1.91753 2.62037L3.84953 9.91877L3.92393 9.90437L4.00073 9.89957H8.20073H12.4007C12.5507 9.89929 12.6953 9.95516 12.8061 10.0562C12.9169 10.1572 12.9858 10.296 12.9994 10.4454C13.0129 10.5947 12.9701 10.7437 12.8793 10.863C12.7885 10.9823 12.6563 11.0633 12.5087 11.09L12.4007 11.0996H8.20073H4.00073C3.96372 11.0997 3.92676 11.0965 3.89033 11.09L1.91873 18.5372L18.0683 10.5788L1.91753 2.62037Z"
                      fill="#ADB2B7"/>
                  </svg>
                </button>
              </v-form>
              <v-progress-linear :class="{form__progress : form_loader}"
                                 :active="form_loader"
                                 indeterminate
                                 rounded
                                 height="6"
              ></v-progress-linear>
              <div v-if="newComment.object_comments_id">{{ $vuetify.lang.t('$vuetify.answer') }}</div>
              <div class="comments__photo flex" id="list"
                   v-if="photoHtml.length + filesHtml.length + editingFiles.length">
                <div v-for="src in photoHtml" :key="src">
                  <img :src="src" alt="photo" @click="showEdit(src)"/>
                  <button class="btn-icon" @click="deleteFile(src)">
                    <v-icon>mdi-close</v-icon>
                  </button>
                </div>
                <div v-for="name in filesHtml" class="file flex" :key="name">
                  <img v-bind="attrs" v-on="on" src="../../assets/img/document-preview.svg" alt="">
                  <button class="btn-icon" @click="deleteFile(name)">
                    <v-icon>mdi-close</v-icon>
                  </button>
                  <span>{{ name }}</span>
                </div>
                <template v-if="newComment.id">
                  <div v-for="doc in editingFiles" :key="doc">
                    <button class="btn-icon" @click="deleteFile(doc)">
                      <v-icon>mdi-close</v-icon>
                    </button>
                    <img
                      v-if="(['png', 'jpg', 'jpeg', 'JPG', 'PNG', 'JPEG'].includes(doc.substr(doc.lastIndexOf('.') + 1)))"
                      :src="$media_url + doc" alt="photo"/>
                    <v-tooltip top v-else :key="doc">
                      <template v-slot:activator="{ on, attrs }">
                        <img v-bind="attrs" v-on="on" class="document-row__photo"
                             src="../../assets/img/document-preview.svg"
                             alt="">
                      </template>
                      <span>{{
                          doc.substr(doc.lastIndexOf('/') + 1, doc.lastIndexOf('_') + 1) + doc.substr(doc.lastIndexOf('.'))
                        }}</span>
                    </v-tooltip>
                  </div>
                </template>
              </div>
              <div class="error--text" v-if="alertError">{{ alertMsg }}</div>
            </div>
          </div>

          <div v-if="tab_selected === 4 && (currentObject.contacts_visible || permissions.admin)"
               class="profile-tabs__content-item">
            <div class="staff">
              <v-checkbox v-if="permissions.admin" v-model="currentObject.contacts_visible"
                          @change="edit_object"
                          :label="$vuetify.lang.t('$vuetify.contactsVisible')"></v-checkbox>
              <div class="staff__item" v-for="item in objectContacts" :key="item.id">
                <div class="staff__avatar">
                  <img v-if="item.contact.photo_path" :src="$media_url + item.contact.photo_path" alt=""/>
                </div>

                <div class="staff__name">
                  {{ item.contact.name }}
                  {{ item.contact.lastname }}
                  <span class="staff__post" v-if="item.contact.position && item.contact.position.name">({{
                      item.contact.position.name[$vuetify.lang.current] ? item.contact.position.name[$vuetify.lang.current] : item.contact.position.name['eng'] ? item.contact.position.name['eng'] : item.contact.position.name['fin']
                    }})</span>
                </div>
                <div class="staff__contact">
                  <a :href="'mailto:' +  item.contact.email">{{ item.contact.email }}</a>
                  <a :href="'tel:' +  item.contact.phone.replace(/\s/g, '')">{{ item.contact.phone }}</a>
                </div>

                <div v-if="edit_perm" class="staff__btns">
                  <button class="btn-icon btn-action" @click="edit_contact_open(item)">
                    <edit-icon/>
                  </button>
                  <button class="btn-icon btn-action" @click="confirm_contact_open(item.id)">
                    <delete-icon/>
                  </button>
                </div>
              </div>
              <v-dialog v-model="editingContact">
                <div class="form__row modal">
                  <v-form ref="contactForm" @submit.prevent="">
                    <v-select v-if="!tmp_contact.id" v-model="tmp_contact.contact" :items="contacts" item-value="id"
                              :placeholder="$vuetify.lang.t('$vuetify.selectContact')" :rules="[$rules.required]"
                              :menu-props="{
                                bottom: true,
                                offsetY: true,
                                maxHeight: 200,
                                contentClass: 'select-menu',
                              }"
                              outlined dense attach>
                      <template v-slot:selection="{ item }">
                        {{ item.name }} {{ item.lastname }}
                        <template v-if="item.position && item.position.name">({{
                            item.position.name[$vuetify.lang.current] ? item.position.name[$vuetify.lang.current] : item.position.name['eng'] ? item.position.name['eng'] : item.position.name['fin']
                          }})
                        </template>
                      </template>
                      <template v-slot:item="{ item }">
                        {{ item.name }} {{ item.lastname }}
                        <template v-if="item.position && item.position.name">
                          ({{
                            item.position.name[$vuetify.lang.current] ? item.position.name[$vuetify.lang.current] : item.position.name['eng'] ? item.position.name['eng'] : item.position.name['fin']
                          }})
                        </template>
                      </template>
                    </v-select>
                    <v-textarea placeholder="Комментарий" v-model="tmp_contact.comment" outlined></v-textarea>
                    <div class="btn-group">
                      <button class="btn btn-secondary" @click="cancelAddContact">
                        {{ $vuetify.lang.t('$vuetify.cancel') }}
                      </button>
                      <button class="btn btn-primary" @click="addObjectContact">
                        {{ $vuetify.lang.t('$vuetify.save') }}
                      </button>
                    </div>
                  </v-form>
                </div>
              </v-dialog>
              <button v-if="!editingContact && edit_perm" class="btn btn-secondary mt-20 mb-40"
                      @click="editingContact = !editingContact">
                + {{ $vuetify.lang.t('$vuetify.addContact') }}
              </button>
            </div>
          </div>

          <div v-if="tab_selected === 6" class="profile-tabs__content-item">
            <div class="documents">
              <div class="page__sorts">
                <button v-if="active" class="btn btn-secondary mt-20 mb-40"
                        @click="addDocumentModal = true">
                  + {{ $vuetify.lang.t('$vuetify.addDocument') }}
                </button>
                <div class="documents__sorts">
                  <div class="sorts__radio">
                    <span>{{ $vuetify.lang.t('$vuetify.dataTable.sortBy') }}</span>
                    <div class="custom-radio">
                      <input v-model="sort" type="radio" name="sort" value="name" id="sort9"
                             class="custom-radio__hide"/>
                      <label for="sort9" class="custom-radio__button"><span></span></label>
                      <label for="sort9">{{ $vuetify.lang.t('$vuetify.sorts.byName') }}</label>
                    </div>
                    <div class="custom-radio">
                      <input v-model="sort" type="radio" name="sort" value="create_date" id="sort7"
                             class="custom-radio__hide"/>
                      <label for="sort7" class="custom-radio__button"><span></span></label>
                      <label for="sort7">{{ $vuetify.lang.t('$vuetify.sorts.byCreateDate') }}</label>
                    </div>
                  </div>
                  <v-select class="sorts__select" v-model="sort"
                            :label="$vuetify.lang.t('$vuetify.dataTable.sortBy')"
                            :items="selectSorts" item-text="name" item-value="value"
                            :menu-props="{
                                      bottom: true,
                                      offsetY: true,
                                      maxHeight: 200,
                                      contentClass: 'select-menu',
                                  }"
                            outlined hide-details attach></v-select>
                </div>
              </div>

              <table>
                <thead>
                <td></td>
                <td>{{ $vuetify.lang.t('$vuetify.documentName') }}</td>
                <td>{{ $vuetify.lang.t('$vuetify.dateDownload') }}</td>
                <td v-if="permissions.edit.indexOf('Объекты') !== -1"></td>
                </thead>
                <tbody>
                <tr v-for="doc in documents" :key="doc.id" @click="downloadDocument(doc)">
                  <td>
                    <img class="document-row__photo"
                         v-if="(['png', 'jpg', 'jpeg', 'JPG', 'PNG', 'JPEG'].includes(doc.path[0].substr(doc.path[0].lastIndexOf('.') + 1)))"
                         :src="$media_url + doc.path[0]" alt="photo"/>
                    <img class="document-row__photo" v-else src="../../assets/img/document-preview.svg" alt="">
                  </td>
                  <td>{{ doc.name }}</td>
                  <td>{{ new Date(doc.create_date).toLocaleDateString('ru-Ru') }}</td>
                  <td class="rows__dot-menu">
                    <v-menu bottom right>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn dark icon v-bind="attrs" v-on="on">
                          <svg
                            v-bind="attrs"
                            v-on="on"
                            width="20"
                            height="5"
                            viewBox="0 0 20 5"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle cx="2" cy="2.5" r="2" fill="#2C1521"/>
                            <circle cx="10" cy="2.5" r="2" fill="#2C1521"/>
                            <circle cx="18" cy="2.5" r="2" fill="#2C1521"/>
                          </svg>
                        </v-btn>
                      </template>
                      <div class="rows__dot-menu-content">
                        <div v-if="permissions.edit.indexOf('Объекты') !== -1" class="btn-wrap"
                             @click="newDocument=doc; addDocumentModal = true">
                          {{ $vuetify.lang.t('$vuetify.edit') }}
                          <button class="btn-icon btn-action">
                            <edit-icon/>
                          </button>
                        </div>
                        <div v-if="permissions.edit.indexOf('Объекты') !== -1" class="btn-wrap"
                             @click="confirm_document_open(doc.id)">
                          {{ $vuetify.lang.t('$vuetify.delete') }}
                          <button class="btn-icon btn-action">
                            <delete-icon/>
                          </button>
                        </div>
                        <div class="btn-wrap" @click="downloadDocument(doc)">
                          {{ $vuetify.lang.t('$vuetify.loadDoc') }}
                          <button class="btn-icon btn-action">
                            <document-icon/>
                          </button>
                        </div>
                      </div>
                    </v-menu>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div v-if="tab_selected === 7" class="profile-tabs__content-item">
            <DGantt
              v-if="permissions.read.indexOf('Диаграмма') != -1"
              :object_id="id"></DGantt>
          </div>
        </div>
      </div>
    </div>
    <CoolLightBox
      :items="lightboxItems"
      :index="index"
      @close="index = null">
    </CoolLightBox>

    <ConfirmModal v-model="confirm_worker_modal" @confirm="worker_delete">
      <span v-if="alertError">{{ alertMsg }}</span>
    </ConfirmModal>
    <ConfirmModal v-model="confirm_contact_modal" @confirm="contact_delete">
      <span v-if="alertError">{{ alertMsg }}</span>
    </ConfirmModal>
    <ConfirmModal v-model="confirm_comment_modal" @confirm="deleteComment">
      <span v-if="alertError">{{ alertMsg }}</span>
    </ConfirmModal>
    <ConfirmModal v-model="confirm_document_modal" @confirm="deleteDocument">
      <span v-if="alertError">{{ alertMsg }}</span>
    </ConfirmModal>
    <ConfirmModal v-model="confirmTimingModal" @confirm="deleteCheckIn">
      <span v-if="alertError">{{ alertMsg }}</span>
    </ConfirmModal>

    <v-dialog v-model="editingWorkers">
      <div class="form__row modal">
        <v-form ref="workerForm" @submit.prevent="">
          <v-select v-if="!tmp_worker.id" v-model="tmp_worker.user_profile_id" :items="workers"
                    item-value="id"
                    :placeholder="$vuetify.lang.t('$vuetify.selectWorker')" :rules="[$rules.required]"
                    :menu-props="{
              bottom: true,
              offsetY: true,
              maxHeight: 200,
              contentClass: 'select-menu',
            }" outlined dense attach>
            <template v-slot:selection="{ item }">
              {{ item.name }} {{ item.lastname }}
              <template v-if="item.position && item.position.name"> ({{
                  item.position.name[$vuetify.lang.current] ? item.position.name[$vuetify.lang.current] : item.position.name['eng'] ? item.position.name['eng'] : item.position.name['fin']
                }})
              </template>
            </template>
            <template v-slot:item="{ item }">
              {{ item.name }} {{ item.lastname }}
              <template v-if="item.position && item.position.name"> ({{
                  item.position.name[$vuetify.lang.current] ? item.position.name[$vuetify.lang.current] : item.position.name['eng'] ? item.position.name['eng'] : item.position.name['fin']
                }})
              </template>
            </template>
          </v-select>
          <div class="form__row">
            <v-menu ref="worker_start" v-model="datePickers.worker_start" :close-on-content-click="false"
                    transition="scale-transition">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="tmp_worker.start_date ? new Date(tmp_worker.start_date).toLocaleDateString('ru-Ru') : ''"
                  :label="$vuetify.lang.t('$vuetify.worksStart')" v-bind="attrs" v-on="on" outlined
                  readonly :rules="[$rules.required]"></v-text-field>
              </template>
              <v-date-picker v-model="tmp_worker.start_date" @input="datePickers.worker_start = false"
                             no-title first-day-of-week="1" show-week locale-first-day-of-year="4"
                             show-adjacent-months>
              </v-date-picker>
            </v-menu>
            <v-menu ref="worker_start" v-model="datePickers.worker_end" :close-on-content-click="false"
                    transition="scale-transition">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="tmp_worker.end_date ? new Date(tmp_worker.end_date).toLocaleDateString('ru-Ru') : ''"
                  :label="$vuetify.lang.t('$vuetify.worksEnd')" v-bind="attrs" v-on="on" outlined
                  readonly></v-text-field>
              </template>
              <v-date-picker v-model="tmp_worker.end_date" @input="datePickers.worker_end = false"
                             no-title first-day-of-week="1" show-week locale-first-day-of-year="4"
                             show-adjacent-months>
              </v-date-picker>
            </v-menu>
          </div>
          <v-textarea :placeholder="$vuetify.lang.t('$vuetify.comment')" v-model="tmp_worker.comment"
                      outlined></v-textarea>
          <div class="btn-group">
            <button class="btn btn-secondary" @click="cancelAddWorker">
              {{ $vuetify.lang.t('$vuetify.cancel') }}
            </button>
            <button class="btn btn-primary" @click="putObjectUser">
              {{ $vuetify.lang.t('$vuetify.save') }}
            </button>
          </div>
        </v-form>
      </div>
    </v-dialog>
    <v-dialog v-model="addDocumentModal">
      <div class="modal modal-big">
        <v-form ref="documentForm" @submit.prevent="">
          <v-text-field v-model="newDocument.name"
                        :label="$vuetify.lang.t('$vuetify.accounting.card.name')" outlined></v-text-field>
          <v-file-input v-if="!newDocument.id" accept=".jpg, .png, .pdf, .doc, .docx" class="file-input" v-model="docs"
                        multiple
                        :placeholder="$vuetify.lang.t('$vuetify.downloadDocument')" prepend-icon="$document"
                        :rules="[$rules.required]"></v-file-input>

          <v-progress-linear :class="{form__progress : form_loader}"
                             :active="form_loader"
                             indeterminate
                             rounded
                             height="6"
          ></v-progress-linear>

          <div v-if="alertError" class="error--text">{{ alertMsg }}</div>
          <div class="btn-group">
            <button class="btn btn-secondary" @click="cancelAddDocument">
              {{ $vuetify.lang.t('$vuetify.cancel') }}
            </button>
            <button class="btn btn-primary" @click="uploadDocumentFiles">
              {{ $vuetify.lang.t('$vuetify.save') }}
            </button>
          </div>
        </v-form>
      </div>
    </v-dialog>
    <v-dialog v-model="timingModal">
      <div class="modal">
        <div class="h1">
          <span>{{ $vuetify.lang.t('$vuetify.addTimeReport') }}</span>
        </div>
        <v-form ref="form" @submit.prevent="checkIn" onkeydown="return event.key !== 'Enter';">
          <v-textarea :label="$vuetify.lang.t('$vuetify.workType')" v-model="checkEntity.position"
                      :rules="[$rules.required]" outlined></v-textarea>
          <v-text-field v-model.number="checkEntity.options.rate" :label="$vuetify.lang.t('$vuetify.wages.rate')"
                        outlined
                        :rules="[$rules.required, $rules.positiveNumbers]"></v-text-field>
          <v-select v-model="checkEntity.options.pause" class="custom"
                    :label="$vuetify.lang.t('$vuetify.pause')"
                    :items="selectPause" item-text="name" item-value="value" outlined attach
                    :menu-props="{
              bottom: true,
              offsetY: true,
              maxHeight: 200,
              contentClass: 'select-menu',
            }">
            <template v-slot:selection="{item }">
              {{ item.value }} {{ $vuetify.lang.t('$vuetify.minutes') }}
            </template>
            <template v-slot:item="{ item }">
              {{ item.value }} {{ $vuetify.lang.t('$vuetify.minutes') }}
            </template>
          </v-select>
          <v-select v-model="checkEntity.options.trip_time" class="custom"
                    :label="$vuetify.lang.t('$vuetify.tripTime')"
                    :items="trips" item-text="name" item-value="minutes" outlined attach
                    :menu-props="{
              bottom: true,
              offsetY: true,
              maxHeight: 200,
              contentClass: 'select-menu',
            }">
            <template v-slot:selection="{item }">
              <template v-if="Math.floor(item.minutes / 60) > 0">
                {{ Math.floor(item.minutes / 60) }} {{ $vuetify.lang.t('$vuetify.hour') }}
              </template>
              {{ item.minutes % 60 }} {{ $vuetify.lang.t('$vuetify.minutes') }}
            </template>
            <template v-slot:item="{ item }">
              <template v-if="Math.floor(item.minutes / 60) > 0">
                {{ Math.floor(item.minutes / 60) }} {{ $vuetify.lang.t('$vuetify.hour') }}
              </template>
              {{ item.minutes % 60 }} {{ $vuetify.lang.t('$vuetify.minutes') }}
            </template>
          </v-select>

          <div class="timing-form__salary">
            {{ $vuetify.lang.t('$vuetify.wages.sum') }}: {{ sum }}
          </div>
          <div class="error--text" v-if="alertError">{{ alertMsg }}</div>
          <div class="sign-up__buttons btn-group">
            <div class="btn btn-secondary" @click.stop="timingModal=false">
              {{ $vuetify.lang.t('$vuetify.cancel') }}
            </div>
            <button class="btn btn-primary">
              {{ $vuetify.lang.t('$vuetify.save') }}
            </button>
          </div>
          <div class="btn btn-primary mt-2" @click.stop="confirmTimingModal = true">
            {{ $vuetify.lang.t('$vuetify.endWithoutReport') }}
          </div>
        </v-form>
      </div>
    </v-dialog>


    <SpinnerLoader :overlay="loader"></SpinnerLoader>

    <v-dialog v-model="isOpenEditImage">
      <ImagePainter :image="currentImage" @updateImage="(im) => updateImage(currentImage, im)"
                    :format="type"></ImagePainter>
    </v-dialog>
    <v-dialog v-model="invite_modal">

      <div class="modal modal-height">
        <h3>
          {{ $vuetify.lang.t('$vuetify.menu.invitePartner') }}

        </h3>
        <form action="">
          <div class="">
        <v-autocomplete v-model="currentObject.organization" class="custom" :label="$vuetify.lang.t('$vuetify.partners')"
                        :items="organizations" item-text="name" item-value="id" outlined attach
                        multiple
                        :menu-props="{
              bottom: true,
              offsetY: true,
              maxHeight: width<1024 ? 300 : 500,
              contentClass: 'select-menu',
            }">
        </v-autocomplete>
        <v-autocomplete v-model="currentObject.clients" class="custom" :label="$vuetify.lang.t('$vuetify.fromNotes')"
                        :items="clients" item-text="name" item-value="id" outlined attach multiple
                        :menu-props="{
              bottom: true,
              offsetY: true,
              axHeight: width<1024 ? 300 : 800,
              contentClass: 'select-menu',
            }"></v-autocomplete>
        <div class="error--text" v-if="alertError">{{ alertMsg }}</div>
          </div>
        <button class="btn btn-primary modal-height-2__footer" @click="invite">
          {{ $vuetify.lang.t('$vuetify.save') }}
        </button>
        </form>
      </div>
    </v-dialog>
  </div>
</template>
<script>
import ConfirmModal from "@/components/confirmModal.vue";
import SpinnerLoader from "@/components/SpinnerLoader";
import DeleteIcon from "@/components/icons/DeleteIcon";
import EditIcon from "@/components/icons/EditIcon";
import DocumentIcon from "@/components/icons/DocumentIcon";
import DownloadIcon from "@/components/icons/DownloadIcon.vue";
import DGantt from "@/components/DGantt.vue";
import {mapActions, mapGetters} from "vuex";
import ImagePainter from "@/components/painter/ImagePainter.vue";

export default {
  name: "object-view",

  components: {
    ImagePainter,
    DGantt,
    DownloadIcon,
    DocumentIcon,
    EditIcon,
    DeleteIcon,
    ConfirmModal,
    SpinnerLoader,
  },

  props: {
    id: String,
  },

  data: function () {
    return {
      width: screen.width,
      invite_modal: false,
      edit_perm: false,
      tab_selected: 1,
      tmp: 5,
      currentObject: {
        business_address: {},
        client_id: {},
      },
      editing: false,
      editingWorkers: false,
      editingContact: false,
      objectContacts: [],
      contacts: [],
      tmp_work_description: [],
      obj_work: "",
      objectWorkers: [],
      workers: [],
      todo: [],
      client_contractors: [],
      org_contractors: [],

      check: false,
      checkEntity: {
        options: {
          rate: 0,
          pause: 0,
        }
      },
      checkList: [],
      geolocation: null,
      timingModal: false,
      selectPause: [
        {name: '0 ' + this.$vuetify.lang.t('$vuetify.minutes'), value: 0},
        {name: '15 ' + this.$vuetify.lang.t('$vuetify.minutes'), value: 15},
        {name: '30 ' + this.$vuetify.lang.t('$vuetify.minutes'), value: 30},
        {name: '1 ' + this.$vuetify.lang.t('$vuetify.hour'), value: 60},
      ],
      trips: [],
      confirmTimingModal: false,

      tmp_worker: {
        id: 0,
        user_profile_id: 0,
        object_id: 0,
        start_date: null,
        end_date: null,
        comment: null,
      },
      worker_to_delete: 0,
      datePickers: {
        worker_start: false,
        worker_end: false,
      },
      confirm_worker_modal: false,

      tmp_contact: {
        id: 0,
        contact: 0,
        object: 0,
        comment: null,
      },
      contact_to_delete: 0,
      confirm_contact_modal: false,

      container: {},
      comments: [],
      answers: [],
      profile: 0,
      newComment: {
        text: "",
        files: [],
        object_comments_id: null,
        objects_id: null,
      },
      editingFiles: [],
      deletedFiles: [],
      commentPhoto: [],
      commentPhotoRow: [],
      photoHtml: [],
      filesHtml: [],
      confirm_comment_modal: false,
      comment_to_delete: 0,
      lightboxItems: [],
      index: null,
      show_smiles: false,
      translated: [],

      documents: [],
      sort: '',
      selectSorts: [
        {name: this.$vuetify.lang.t('$vuetify.sorts.byName'), value: 'name'},
        {name: this.$vuetify.lang.t('$vuetify.sorts.byCreateDate'), value: 'create_date'},
      ],
      newDocument: {
        name: '',
        path: [],
        objects_id: this.id
      },
      docs: [],
      loadedFiles: 0,
      addDocumentModal: false,
      document_to_delete: 0,
      confirm_document_modal: false,

      alertMsg: "",
      alertError: false,
      loader: false,
      form_loader: false,
      slider: 0,
      screenWidth: window.screen.width,
      geoError: "",


      isOpenEditImage: false,
      currentImage: null,
      type: null,

      clients: [],
      organizations: [],
    };
  },

  watch: {
    commentPhotoRow() {
      if (
        this.commentPhoto.length === this.commentPhotoRow.length &&
        this.commentPhotoRow.length
      ) {
        this.addComment();
      }
    },

    tab_selected() {
      if (this.tab_selected === 3) {
        this.scrollComments();
      }
    },
    comments() {
      this.scrollComments();
    },

    loadedFiles: function (val) {
      if (val === this.docs.length) {
        this.newDocument.name = this.newDocument.name ? this.newDocument.name : this.docs[0].name
        this.addDocument()
      }
    },
    sort() {
      this.loadDocuments()
    },
  },

  computed: {
    ...mapGetters(['permissions']),
    ...mapGetters(['active']),

    sum: function () {
      let val = this.checkEntity.options.rate * (this.checkEntity.options.quantity || this.hours)
      if (val)
        return Number(val.toFixed(2))
      else
        return '- - -'
    },
    hours: function () {
      if (this.checkEntity.time_end && this.checkEntity.time_start) {
        let getDate = (string) => new Date(0, 0, 0, string.split(':')[0], string.split(':')[1]); //получение даты из строки (подставляются часы и минуты
        let different = (getDate(this.checkEntity.time_end) - getDate(this.checkEntity.time_start)) - (this.checkEntity.options.pause ?? 0) * 60000 + (this.checkEntity.options.trip_time ?? 0) * 60000;

        return (different % 86400000) / 3600000
      } else return 0
    },
    workerInfoMap() {
      const map = {};
      this.checkList.forEach(check => {
        map[check.user_profile_id] = {
          time: check.time_start,
          geo: check.geo_start
        };
      });
      return map;
    }
  },

  mounted: function () {
    this.checkPermission('Объекты').then(() => {
      this.loadData();
      this.loadWorkers();
      this.loadObjectContacts();
      this.loadComments();
      this.loadDocuments();
      this.loadContractors();
      this.loadCheckIn();

      this.edit_perm = this.permissions.edit.indexOf('Объекты') !== -1
      if (this.edit_perm) {
        this.loadSelectWorkers();
        this.loadClients();
      }
      if (this.$route.query.tab) {
        this.tab_selected = parseInt(this.$route.query.tab)
        this.readComments()
      }
      this.$nextTick(() => {
        window.addEventListener('resize', this.onResize);
      })
      window.navigator.geolocation.getCurrentPosition(
        position => {
          this.geolocation = position.coords.latitude.toFixed(5) + ", " + position.coords.longitude.toFixed(5);
        }, () => {
          this.geoError = 'System/OS services disabled, turn on and reload page';
        }, {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0,
        });
    })
  },

  methods: {
    ...mapActions(['checkPermission']),

    invite(){

      this.$axios({
        url: this.$hostname + "time-tracking/invitations",
        method: "PUT",
        headers: {
          Authorization:
              "Token " +
              (localStorage.getItem("auth_token") ||
                  sessionStorage.getItem("auth_token")),
        },
        data: {
          clients: JSON.stringify(this.currentObject.clients),
          partners: JSON.stringify(this.currentObject.organization),
        }
      }).then(response=>{
        console.log(response.data)
        this.invite_modal = false
      }).catch(response=>{
        this.alertMsg = this.$catch(response);
        this.alertError = true;
      })

    },

    loadClients() {
      this.$axios({
        url: this.$hostname + "time-tracking/clients",
        method: "GET",
        headers: {
          Authorization:
              "Token " +
              (localStorage.getItem("auth_token") ||
                  sessionStorage.getItem("auth_token")),
        },
        params: {
          arch: !false,
        }
      })
          .then((response) => {
            this.clients = response.data.data.data;
            this.organizations = response.data.data.partners;
          })
          .catch((response) => {
            this.alertMsg = this.$catch(response);
            this.alertError = true;
          });
    },


    openInvite(){
      this.invite_modal = true
    },

    updateImage(currentImage, newImage) {
      this.$data.isOpenEditImage = false

      const index = this.photoHtml.indexOf(currentImage)
      this.commentPhoto[index] = new File([newImage], this.commentPhoto[index].name, {
        ...this.commentPhoto[index],
        type: this.commentPhoto[index].type
      })

      const reader = new FileReader()

      reader.onload = (e) => {
        this.photoHtml[index] = e.target.result
        this.$forceUpdate()
      }

      reader.readAsDataURL(this.commentPhoto[index])
    },
    showEdit(file) {
      this.$data.currentImage = file
      this.$data.type = this.$data.commentPhoto[this.photoHtml.indexOf(file)].type
      this.$data.isOpenEditImage = true
    },
    onResize() {
      this.screenWidth = window.screen.width
    },
    loadData: function () {
      this.loader = true
      this.$axios({
        url: this.$hostname + "time-tracking/object/" + this.id,
        method: "GET",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
        },
      }).then((response) => {
        this.currentObject = response.data.data.data;

        this.currentObject.work_description = JSON.parse(
          this.currentObject.work_description
        );
        this.tmp_work_description = structuredClone(
          this.currentObject.work_description
        );
        this.loadTodo();
      }).catch((response) => {
        this.alertMsg = this.$catch(response);
        this.alertError = true;
      }).then(() => {
        this.loader = false
      })
    },

    loadWorkers() {
      this.$axios({
        url: this.$hostname + "time-tracking/objects/employees/" + this.id,
        method: "GET",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
        },
      })
        .then((response) => {
          this.objectWorkers = response.data.data.data;
        })
        .catch((response) => {
          this.alertMsg = this.$catch(response);

          this.alertError = true;
        });
    },
    loadSelectWorkers() {
      this.$axios({
        url: this.$hostname + "time-tracking/profiles/active",
        method: "GET",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
        },
        params: {
          object: this.id
        }
      })
        .then((response) => {
          this.workers = response.data.data.data;
        })
        .catch((response) => {
          this.alertMsg = this.$catch(response);
          this.alertError = true;
        });
    },
    loadObjectContacts() {
      this.$axios({
        url: this.$hostname + "time-tracking/objects/contacts/" + this.id,
        method: "get",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
        },
      })
        .then((response) => {
          if (response.data.data.data) {
            this.objectContacts = response.data.data.data;
            this.contacts = response.data.data.contacts;
          }
        })
        .catch((error) => {
          this.alertMsg = this.$catch(error);
          this.alertError = true;
        });
    },
    loadContacts() {
      this.$axios({
        url: this.$hostname + "time-tracking/clients-employees",
        method: "get",
        params: {
          client: "Все",
          position: "Все",
        },
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
        },
      })
        .then((response) => {
          if (response.data.data.data) {
            this.contacts = response.data.data.data;
          }
        })
        .catch((error) => {
          this.alertMsg = this.$catch(error);
          this.alertError = true;
        });
    },
    loadComments() {
      this.$axios({
        url: this.$hostname + "time-tracking/objects/comments/" + this.id,
        method: "GET",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
        },
      })
        .then((response) => {
          this.comments = response.data.data.comments;
          this.answers = response.data.data.data;
          this.profile = response.data.data.profile;

          this.comments.forEach(com => {
            this.parseCommentFiles(com)
            this.parseCommentLinks(com);

            this.answers[com.id].forEach(com_ans => {
              this.parseCommentFiles(com_ans)
              this.parseCommentLinks(com);
            });
          });

          this.alertError = false;
        })
        .catch((response) => {
          this.alertMsg = this.$catch(response);
          this.alertError = true;
        });
    },
    parseCommentFiles(com) {
      if (com.files != null && com.files != '') {
        com.files = JSON.parse(com.files);
        for (let i = 0; i < com.files.length; i++) {
          if (['png', 'jpg', 'jpeg'].includes(com.files[i].substr(com.files[i].lastIndexOf('.') + 1).toLowerCase())) {
            this.lightboxItems.push(this.$media_url + com.files[i]);
          }
        }
      }
    },
    parseCommentLinks(comment) {
      const urlRegex = /(https?:\/\/[^\s]+)/g;
      comment.display_text = comment.text.replace(urlRegex, function (url) {
        return '<a href="' + url + '" target="_blank">' + url + '</a>';
      });
    },
    loadDocuments() {
      this.$axios({
        url: this.$hostname + "time-tracking/objects/documents/" + this.id,
        method: "GET",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        params: {
          sort: this.sort
        }
      })
        .then((response) => {
          this.documents = response.data.data.data
          this.documents.forEach(doc => {
            doc.path = JSON.parse(doc.path)
          })
        })
        .catch((response) => {
          this.alertMsg = this.$catch(response);
          this.alertError = true;
        });
    },
    loadTodo() {
      this.$axios({
        url: this.$hostname + "time-tracking/todo",
        method: "GET",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
        },
        params: {
          range: JSON.stringify(this.range),
          object: this.id,
        },
      }).then((response) => {
        if (response.data.data.data) {
          this.todo = response.data.data.data;
        }
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      })
    },
    loadCheckIn() {
      this.$axios({
        url: this.$hostname + "time-tracking/checkin/" + this.id,
        method: "GET",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
        },
      }).then((response) => {
        if (response.data.data.check) {
          this.checkEntity = response.data.data.check;
          if (this.checkEntity.id) {
            this.check = true
          } else {
            this.checkEntity.options = {
              rate: 0,
              pause: 0,
            }
          }
        }
        if (response.data.data.data) {
          this.checkList = response.data.data.data;
        }
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      })
    },
    loadTripTime() {
      this.$axios({
        url: this.$hostname + "time-tracking/trip-time",
        method: "GET",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
        },
      }).then((response) => {
        this.trips = response.data.data.data
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      })
    },
    loadContractors() {
      this.$axios({
        url: this.$hostname + "time-tracking/object/contractors",
        method: "GET",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
        },
        params: {
          object: this.id,
        },
      }).then((response) => {
        if (response.data.data.data) {
          this.client_contractors = response.data.data.clients;
          this.org_contractors = response.data.data.organizations;
        }
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      })
    },

    scrollComments() {
      this.$nextTick(() => {
        if (document.getElementById("comments__list"))
          document.getElementById("comments__list").scrollTop =
            document.getElementById("comments__list").scrollHeight;
      });
    },
    confirm_edit() {
      this.currentObject.work_description = structuredClone(
        this.tmp_work_description
      );
      this.edit_object()
      this.editing = false;
    },
    edit_object() {
      this.$axios({
        url: this.$hostname + "time-tracking/objects",
        method: "PUT",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: {
          id: this.id,
          work_description: JSON.stringify(this.currentObject.work_description),
          contacts_visible: this.currentObject.contacts_visible,
        },
      })
        .then(() => {
        }).catch((response) => {
        this.alertMsg = this.$catch(response);
        this.alertError = true;
      });
    },

    confirm_worker_open(id) {
      this.confirm_worker_modal = true;
      this.worker_to_delete = id;
    },
    edit_worker_open(item) {
      this.tmp_worker = item;
      this.editingWorkers = true;
    },
    putObjectUser() {
      if (this.$refs.workerForm.validate()) {
        this.tmp_worker.object_id = this.id;
        this.$axios({
          url: this.$hostname + "time-tracking/objects/employees",
          method: "PUT",
          data: {
            id: this.tmp_worker.id,
            user_profile_id: this.tmp_worker.user_profile_id.id
              ? this.tmp_worker.user_profile_id.id
              : this.tmp_worker.user_profile_id,
            objects_id: this.id,
            start_date: this.tmp_worker.start_date,
            end_date: this.tmp_worker.end_date,
            comment: this.tmp_worker.comment,
          },
          headers: {
            Authorization:
              "Token " +
              (localStorage.getItem("auth_token") ||
                sessionStorage.getItem("auth_token")),
            "Content-Type": "multipart/form-data",
          },
        })
          .then(() => {
            this.loadWorkers();
            this.cancelAddWorker();
            this.loadSelectWorkers();
          })
          .catch((response) => {
            this.alertMsg = this.$catch(response);
            this.alertError = true;
          });
      }
    },
    worker_delete() {
      this.$axios({
        url: this.$hostname + "time-tracking/objects/employees",
        method: "DELETE",
        data: {
          id: this.worker_to_delete,
        },
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
      })
        .then(() => {
          this.loadWorkers();
          this.confirm_worker_modal = false;
          this.loadSelectWorkers();
        })
        .catch((response) => {
          this.alertMsg = this.$catch(response);
          this.alertError = true;
        });
    },
    cancelAddWorker() {
      this.tmp_worker = {
        id: 0,
        user_profile_id: 0,
        object_id: 0,
        start_date: null,
        end_date: null,
        comment: null,
      };
      this.editingWorkers = false;
    },

    confirm_contact_open(id) {
      this.confirm_contact_modal = true;
      this.contact_to_delete = id;
    },
    edit_contact_open(item) {
      this.tmp_contact = item;
      this.editingContact = true;
    },
    addObjectContact() {
      if (this.$refs.contactForm.validate()) {
        if (this.tmp_contact.id === 0) {
          this.tmp_contact.object = this.id;
          this.$axios({
            url: this.$hostname + "time-tracking/objects/contacts",
            method: "POST",
            data: {
              id: this.tmp_contact.id,
              contact: this.tmp_contact.contact.id
                ? this.tmp_contact.contact.id
                : this.tmp_contact.contact,
              object: this.id,
              comment: this.tmp_contact.comment,
            },
            headers: {
              Authorization:
                "Token " +
                (localStorage.getItem("auth_token") ||
                  sessionStorage.getItem("auth_token")),
              "Content-Type": "multipart/form-data",
            },
          })
            .then(() => {
              this.loadObjectContacts();
              this.cancelAddContact();
            })
            .catch((response) => {
              this.alertMsg = this.$catch(response);
              this.alertError = true;
            });
        } else {
          this.putObjectContact();
        }
      }
    },
    putObjectContact() {
      if (this.$refs.contactForm.validate()) {
        this.tmp_contact.object = this.id;
        this.$axios({
          url: this.$hostname + "time-tracking/objects/contacts",
          method: "PUT",
          data: {
            id: this.tmp_contact.id,
            contact: this.tmp_contact.contact.id
              ? this.tmp_contact.contact.id
              : this.tmp_contact.contact,
            object: this.id,
            comment: this.tmp_contact.comment,
          },
          headers: {
            Authorization:
              "Token " +
              (localStorage.getItem("auth_token") ||
                sessionStorage.getItem("auth_token")),
            "Content-Type": "multipart/form-data",
          },
        })
          .then(() => {
            this.loadObjectContacts();
            this.cancelAddContact();
          })
          .catch((response) => {
            this.alertMsg = this.$catch(response);
            this.alertError = true;
          });
      }
    },
    contact_delete() {
      this.$axios({
        url: this.$hostname + "time-tracking/objects/contacts",
        method: "DELETE",
        data: {
          id: this.contact_to_delete,
        },
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
      })
        .then(() => {
          this.loadObjectContacts();
          this.confirm_contact_modal = false;
        })
        .catch((response) => {
          this.alertMsg = this.$catch(response);
          this.alertError = true;
        });
    },
    cancelAddContact() {
      this.tmp_contact = {
        id: 0,
        contact: 0,
        object: 0,
        comment: null,
      };
      this.editingContact = false;
    },

    addComment() {
      this.form_loader = true
      if (this.newComment.id) {
        this.putComment()
      } else {
        this.newComment.objects_id = this.id;
        this.newComment.files = JSON.stringify(this.commentPhotoRow)
        this.$axios({
          url: this.$hostname + "time-tracking/objects/comments",
          method: "POST",
          headers: {
            Authorization:
              "Token " +
              (localStorage.getItem("auth_token") ||
                sessionStorage.getItem("auth_token")),
            "Content-Type": "multipart/form-data",
          },
          data: this.newComment,
        })
          .then(() => {
            this.loadComments();
            this.newComment = {
              text: "",
              files: [],
              object_comments_id: null,
              objects_id: null,
            };
            this.commentPhoto = [];
            this.commentPhotoRow = [];
            this.photoHtml = [];
            this.filesHtml = [];
            this.deletedFiles = [];
          })
          .catch((response) => {
            this.alertMsg = this.$catch(response);
            this.alertError = true;
          }).finally(() => {
          this.form_loader = false
        });
      }
    },
    putComment() {
      this.newComment.files = JSON.stringify(this.editingFiles.concat(this.commentPhotoRow))
      this.$axios({
        url: this.$hostname + "time-tracking/objects/comments",
        method: "PUT",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: this.newComment,
      })
        .then(() => {
          this.loadComments();
          this.cancel_edit_comment()
        })
        .catch((response) => {
          this.alertMsg = this.$catch(response);
          this.alertError = true;
        }).finally(() => {
        this.form_loader = false
      });
    },
    deleteComment() {
      this.$axios({
        url: this.$hostname + "time-tracking/objects/comments/" + this.comment_to_delete,
        method: "DELETE",
        data: this.comment_to_delete,
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
      }).then(() => {
        this.loadComments()
        this.confirm_comment_modal = false
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      })
    },
    answerStart(id) {
      this.newComment.object_comments_id = id
    },
    edit_comment_open(com) {
      this.newComment = structuredClone(com)
      this.editingFiles = structuredClone(com.files)
    },
    cancel_edit_comment() {
      this.newComment = {
        text: "",
        files: [],
        object_comments_id: null,
        objects_id: null,
      };
      this.commentPhoto = [];
      this.commentPhotoRow = [];
      this.photoHtml = [];
      this.filesHtml = [];
      this.deletedFiles = [];
    },
    deleteFile(file) {
      if (this.newComment.id) {
        let idx = this.newComment.files.findIndex(doc => {
          return doc === file
        })
        let idx_edit = this.editingFiles.findIndex(doc => {
          return doc === file
        })
        if (idx !== -1) {
          this.deletedFiles.push(file)
          this.newComment.files.splice(idx, 1)
        }
        if (idx_edit !== -1) {
          this.editingFiles.splice(idx_edit, 1)
        }
      }

      var idx = this.commentPhoto.findIndex(f => {
        if (!f.type.match("image.*")) {
          return f.name == file
        } else {
          var fr = new FileReader();
          fr.onload = (() => {
            return (e) => {
              return e.target.result
            };
          })(f);
          return f.src == file
        }
      })
      if (idx > -1) {
        this.commentPhoto.splice(idx, 1)
      }

      ['photoHtml', 'filesHtml'].forEach((propertyName) => {
        const index = this[propertyName].findIndex(f => {
          return f === file;
        });
        if (index > -1) {
          this[propertyName].splice(index, 1);
        }
      });
      this.$forceUpdate()
    },
    confirm_comment_open(id) {
      this.confirm_comment_modal = true;
      this.comment_to_delete = id;
    },
    openLightbox(com, index) {
      this.index = this.lightboxItems.findIndex(file => {
        return file == (this.$media_url + com.files[index])
      })
    },
    readComments() {
      if (this.$parent.type === 'client')
        return
      this.$axios({
        url: this.$hostname + "time-tracking/objects/comments-read",
        method: "DELETE",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: {
          object: this.id,
        },
      })
        .then(() => {
          this.$emit("changes")
        })
        .catch((response) => {
          this.alertMsg = this.$catch(response);
          this.alertError = true;
        });
    },
    translateCom: function (com) {
      this.translated.push(com.id)
      this.$axios({
        url: "https://translation.googleapis.com/language/translate/v2?key=AIzaSyCcA3--66Nt9HiqrZeamki4_ZcG1KeJOL0",
        method: "POST",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        params: {
          q: com.text,
          target: this.$vuetify.lang.current === "est" ? "et" : this.$vuetify.lang.current.substr(0, 2),
          format: "html"
        }
      })
        .then((response) => {
          com.translated = response.data.data.translations[0].translatedText
          this.$forceUpdate()
        })
        .catch((response) => {
          this.alertMsg = this.$catch(response);
          this.alertError = true;
        });
    },

    checkFiles(com) {
      let flag = false
      if (com.files && com.files.length) {
        com.files.forEach(file => {
          if (['png', 'jpg', 'jpeg', 'JPG', 'PNG', 'JPEG'].includes(file.substr(file.lastIndexOf('.') + 1))) {
            flag = true
          }
        })
      }
      return flag
    },
    downloadAllCommentFiles() {
      this.comments.forEach(com => {
        if (com.files && com.files.length) {
          this.downloadCommentFiles(com)
          this.answers[com.id].forEach(com_ans => {
            if (com_ans.files && com_ans.files.length) {
              this.downloadCommentFiles(com_ans)
            }
          })
        }
      })
    },
    async downloadCommentFiles(com) {
      this.loader = true
      for (let i = 0; i < com.files.length; i++) { // Используем цикл for, чтобы работал await
        const file = com.files[i];
        let name = file.substring(file.lastIndexOf('/') + 1, file.lastIndexOf('_')) + file.substring(file.lastIndexOf('.'));
        if (['png', 'jpg', 'jpeg', 'JPG', 'PNG', 'JPEG'].includes(file.substring(file.lastIndexOf('.') + 1))) {
          await this.$axios({
            url: this.$hostname + 'media/' + file,
            method: 'GET',
            responseType: 'blob',
          }).then((response) => {
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement('a');

            fileLink.href = fileURL;
            fileLink.setAttribute('download', name);
            document.body.appendChild(fileLink);

            fileLink.click();

            // Удаляем ссылку после клика
            document.body.removeChild(fileLink);
          }).catch((error) => {
            this.alertMsg = this.$catch(error)
            this.alertError = true
          });

          // Добавляем задержку перед загрузкой следующего файла
          await new Promise(resolve => setTimeout(resolve, 100)); // Задержка 100 мс
        }
      }
      this.loader = false
    },
    async uploadFile(file) {
      await this.$axios({
        url: this.$hostname + "time-tracking/images/upload/objects",
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
        },
        data: {
          file: file,
        },
      })
        .then((response) => {
          this.commentPhotoRow.push(response.data.data)
        })
        .catch((error) => {
          alert("Ошибка загрузки файла: " + error.message);
        });

      await new Promise(resolve => setTimeout(resolve, 100)); // Задержка 100 мс
    },
    submitComment() {
      if (this.$refs.comment.validate()) {
        if (this.commentPhoto.length) {
          this.loader = true
          this.commentPhoto.forEach((photo) => {
            this.uploadFile(photo);
          });
          this.loader = false
        } else this.addComment();
      } else {
        this.alertMsg = "Слишком большой файл"
        this.alertError = true
      }
    },
    enterSmile(smile) {
      this.newComment.text += smile
      this.show_smiles = false
    },

    obj_work_add() {
      this.tmp_work_description.push(this.obj_work);
      this.obj_work = "";
    },

    clickInput() {
      document.getElementById("photo").click();
    },
    // eslint-disable-next-line no-cond-assign,no-unused-vars
    showFile(e) {
      var files = this.commentPhoto;
      this.filesHtml = [];
      this.photoHtml = [];
      // eslint-disable-next-line no-cond-assign
      for (var i = 0, f; (f = files[i]); i++) {
        if (!f.type.match("image.*")) {
          this.filesHtml.push(f.name)
        } else {
          var fr = new FileReader();
          fr.onload = (() => {
            return (e) => {
              this.photoHtml.push(e.target.result);
            };
          })(f);
          fr.readAsDataURL(f);
        }
      }
    },

    downloadDocument(item) {
      if (item.path.length === 1 && (['png', 'jpg', 'jpeg', 'JPG', 'PNG', 'JPEG'].includes(item.path[0].substr(item.path[0].lastIndexOf('.') + 1)))) {
        this.lightboxItems.push(this.$media_url + item.path[0])
        this.index = 0
      } else {
        let path = ''
        if (item.zip) {
          path = item.zip
        } else {
          path = item.path[0]
        }
        let name = path.substr(path.lastIndexOf('/') + 1, path.lastIndexOf('_')) + path.substr(path.lastIndexOf('.'))
        this.$axios({
          url: this.$hostname + 'media/' + path,
          method: 'GET',
          responseType: 'blob',
        }).then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');

          fileLink.href = fileURL;
          fileLink.setAttribute('download', name);
          document.body.appendChild(fileLink);

          fileLink.click();
        })
      }
    },
    addDocument() {
      if (this.newDocument.id)
        this.putDocument()
      else {
        this.newDocument.path = JSON.stringify(this.newDocument.path)
        this.$axios({
          url: this.$hostname + "time-tracking/objects/documents/" + this.id,
          method: "POST",
          headers: {
            Authorization:
              "Token " +
              (localStorage.getItem("auth_token") ||
                sessionStorage.getItem("auth_token")),
            "Content-Type": "multipart/form-data",
          },
          data: this.newDocument,
        })
          .then(() => {
            this.loadDocuments();
            this.newDocument = {
              name: '',
              path: [],
              objects_id: this.id
            }
            this.docs = []
            this.addDocumentModal = false
          })
          .catch((response) => {
            this.alertMsg = this.$catch(response);
            this.alertError = true;
          }).then(() => {
          this.form_loader = false
        })
      }
    },
    putDocument() {
      this.$axios({
        url: this.$hostname + "time-tracking/objects/documents/" + this.id,
        method: "PUT",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: this.newDocument,
      })
        .then(() => {
          this.loadDocuments();
          this.newDocument = {
            name: '',
            path: [],
            objects_id: this.id
          }
          this.docs = []
          this.addDocumentModal = false
        })
        .catch((response) => {
          this.alertMsg = this.$catch(response);
          this.alertError = true;
        }).then(() => {
        this.form_loader = false
      })
    },
    deleteDocument() {
      this.$axios({
        url: this.$hostname + "time-tracking/objects/documents/" + this.id,
        method: "DELETE",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: {
          id: this.document_to_delete
        },
      })
        .then(() => {
          this.loadDocuments();
          this.confirm_document_modal = false
        })
        .catch((response) => {
          this.alertMsg = this.$catch(response);
          this.alertError = true;
        });
    },
    uploadDocumentFiles() {
      if (this.$refs.documentForm.validate()) {
        this.form_loader = true
        if (this.newDocument.id)
          this.putDocument()
        else {
          this.docs.forEach(doc => {
            this.$axios({
              url: this.$hostname + "time-tracking/images/upload/" + "objects",
              method: "POST",
              headers: {
                Authorization:
                  "Token " +
                  (localStorage.getItem("auth_token") ||
                    sessionStorage.getItem("auth_token")),
                "Content-Type": "multipart/form-data",
              },
              data: {
                file: doc,
              },
            })
              .then((response) => {
                this.newDocument.path.push(response.data.data)
                this.loadedFiles++
              })
              .catch((error) => {
                alert("Ошибка загрузки файла: " + error.message);
              });

          })
        }
      } else {
        this.alertMsg = "Заполните обязательные поля"
        this.alertError = true
      }
    },
    confirm_document_open(id) {
      this.confirm_document_modal = true;
      this.document_to_delete = id;
    },
    cancelAddDocument() {
      this.newDocument = {
        name: '',
        path: [],
        objects_id: this.id
      };
      this.addDocumentModal = false;
    },

    editTodo(todo) {
      this.$axios({
        url: this.$hostname + "time-tracking/todo",
        method: "PUT",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: {
          items: JSON.stringify([{
            date: todo.date,
            object: todo.objects,
            user_profile: todo.user_profile.id,
            time: todo.time,
            comment: todo.comment,
            id: todo.id ?? 0,
            done: todo.done
          }]),
        },
      }).then(() => {
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      })
    },

    changeCheck() {
      this.check = !this.check
      this.check ? this.checkIn() : this.checkOut()
    },
    checkIn() {
      if (this.check) {
        this.checkEntity = {
          "date": new Date().toISOString().substr(0, 10),
          "objects_id": this.id,
          "time_start": new Date().toLocaleTimeString(),
          "geo_start": this.geolocation,
        }
      } else {
        this.checkEntity.options.hours = this.hours
        this.checkEntity.options = JSON.stringify(this.checkEntity.options)
      }
      this.$axios({
        url: this.$hostname + "time-tracking/checkin",
        method: this.check ? "POST" : "PUT",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: this.checkEntity,
      }).then(() => {
        this.timingModal = false
        this.loadCheckIn()
      }).catch((response) => {
        window.alert(this.$catch(response))
        this.checkEntity.options = JSON.parse(this.checkEntity.options)
      })
    },
    checkOut() {
      this.loadTripTime()
      this.checkEntity.time_end = new Date().toLocaleTimeString()
      this.checkEntity.geo_end = this.geolocation
      this.checkEntity.options = {
        "rate": 0,
        "hours": this.hours,
        "pause": 0,
        "trip_time": 0,
      }
      this.checkEntity.position = ""
      this.timingModal = true
    },
    deleteCheckIn() {
      this.$axios({
        url: this.$hostname + "time-tracking/checkin",
        method: "DELETE",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: this.checkEntity,
      }).then(() => {
        this.timingModal = false
        this.confirmTimingModal = false
        this.loadCheckIn()
      }).catch((response) => {
        this.alertMsg = this.$catch(response)

      })
    }
  }
};
</script>
